import { store } from '@/store';

export default {

    format(val, project = null) {
        if (val === null || val.length === 0) {
            return;
        }
        let currency = project ? project.currency : store.getters.project.currency;
        let params = {
            style: 'currency',
            currency: currency || 'USD'
        };
        val = parseFloat(val) || 0;
        return new Intl.NumberFormat('en-US', params).format(val);
    },

}